export default __webpack_public_path__ + "static/media/gallery_15.29f28d11.jpg";